<template>
  <button style="width: 100%;" class="settings">
    <div style="display: flex;flex-direction: row; justify-content: space-between; width: 100%;" :style="{direction:direction}" class="wrap-loc">
      
      <div class="btn-options" v-if="dots.fifth" style="z-index:30;position:relative; padding: 4px 0px 4px 0px !important;width: 160px; border-radius: 16px;  margin-right: 5px; pointer-events: none;">
        <svg style="position:absolute; right: 19px; top:5px" width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 2.5H3M18 2.5H7" stroke="white" stroke-linecap="round"/>
      <path d="M1 8.5H12M18 8.5H16" stroke="white" stroke-linecap="round"/>
      <path d="M1 14.5H7M18 14.5H11" stroke="white" stroke-linecap="round"/>
      <circle cx="5" cy="2.5" r="2" stroke="white"/>
      <circle cx="14" cy="8.5" r="2" stroke="white"/>
      <circle cx="9" cy="14.5" r="2" stroke="white"/>
      </svg>
      <span class="open" style="margin-right: 20px;">
        {{$ml.get("התאמת משחקים")}}
      </span>
      </div>

      <div class="btn-options" v-else @click="$router.push({path: '/playlist/options'})" style="position:relative; padding: 4px 0px 4px 0px !important;width: 160px; border-radius: 16px;  margin-right: 5px;">
      <!-- <svg style="position:absolute; right: 18px; top:4px" width="16" height="19" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.7123 8.795C13.7123 8.55376 13.7891 8.23576 13.7891 7.99452C13.8033 7.72536 13.7774 7.45559 13.7123 7.19404L15.39 5.9988C15.435 5.96964 15.4731 5.93114 15.5018 5.88592C15.5305 5.8407 15.5492 5.78982 15.5564 5.73675C15.5637 5.68368 15.5595 5.62967 15.544 5.57838C15.5286 5.5271 15.5022 5.47975 15.4668 5.43956L13.8658 2.64337C13.8541 2.59325 13.8314 2.54633 13.7995 2.50594C13.7676 2.46555 13.7272 2.43268 13.6812 2.40966C13.6351 2.38664 13.5845 2.37403 13.5331 2.37273C13.4816 2.37142 13.4305 2.38146 13.3834 2.40212L11.4644 3.27937C11.0322 2.93641 10.547 2.66605 10.0279 2.47888L9.78669 0.395444C9.78989 0.34277 9.78187 0.290015 9.76316 0.240669C9.74446 0.191324 9.71548 0.146513 9.67816 0.109198C9.64085 0.0718827 9.59603 0.0429138 9.54669 0.0242078C9.49734 0.00550176 9.44459 -0.00251464 9.39191 0.000686772H6.19001C6.13734 -0.00251464 6.08459 0.00550176 6.03524 0.0242078C5.9859 0.0429138 5.94108 0.0718827 5.90376 0.109198C5.86645 0.146513 5.83747 0.191324 5.81877 0.240669C5.80006 0.290015 5.79204 0.34277 5.79524 0.395444L5.554 2.39116C5.04145 2.59238 4.55829 2.86162 4.11752 3.19164L2.19857 2.39116C2.11195 2.35477 2.01499 2.35142 1.92607 2.38173C1.83715 2.41205 1.76243 2.47393 1.71608 2.55564L0.115133 5.35184C-0.0493491 5.59308 -0.0493411 5.83432 0.191899 5.91108L1.88059 7.22693C1.88059 7.46817 1.80383 7.78617 1.80383 8.02741C1.7896 8.29657 1.81548 8.56634 1.88059 8.82789L0.202842 10.0231C0.157907 10.0523 0.119788 10.0908 0.0910724 10.136C0.0623564 10.1812 0.0437433 10.2321 0.0364592 10.2852C0.0291752 10.3382 0.033404 10.3923 0.0488743 10.4435C0.0643447 10.4948 0.0906931 10.5422 0.126109 10.5824L1.72706 13.3566C1.73882 13.4068 1.76147 13.4537 1.79338 13.4941C1.8253 13.5344 1.8657 13.5673 1.91175 13.5903C1.95779 13.6134 2.00836 13.626 2.05982 13.6273C2.11129 13.6286 2.16239 13.6185 2.20954 13.5979L4.1285 12.7206C4.56075 13.0636 5.04591 13.3339 5.56497 13.5211L5.80622 15.6046C5.80301 15.6572 5.81104 15.71 5.82974 15.7593C5.84845 15.8087 5.87742 15.8535 5.91474 15.8908C5.95205 15.9281 5.99684 15.9571 6.04619 15.9758C6.09553 15.9945 6.14828 16.0025 6.20096 15.9993H9.40289C9.45556 16.0025 9.50832 15.9945 9.55766 15.9758C9.60701 15.9571 9.65183 15.9281 9.68914 15.8908C9.72646 15.8535 9.75543 15.8087 9.77414 15.7593C9.79285 15.71 9.80083 15.6572 9.79763 15.6046L10.0389 13.5211C10.5514 13.3199 11.0346 13.0507 11.4754 12.7206L13.3943 13.5979C13.481 13.6343 13.5779 13.6376 13.6668 13.6073C13.7557 13.577 13.8304 13.5151 13.8768 13.4334L15.4778 10.6372C15.5237 10.5473 15.541 10.4455 15.5272 10.3455C15.5135 10.2455 15.4695 10.1521 15.401 10.078L13.7123 8.795ZM7.79096 11.1964C7.15768 11.1964 6.53864 11.0086 6.01209 10.6568C5.48553 10.305 5.07513 9.80491 4.83278 9.21984C4.59044 8.63477 4.52702 7.99097 4.65057 7.36985C4.77412 6.74874 5.07906 6.17822 5.52686 5.73042C5.97466 5.28262 6.54518 4.97767 7.16629 4.85412C7.7874 4.73057 8.43121 4.79399 9.01628 5.03633C9.60136 5.27868 10.1014 5.68907 10.4533 6.21563C10.8051 6.74218 10.9929 7.36124 10.9929 7.99452C10.99 8.84283 10.6517 9.65557 10.0519 10.2554C9.45201 10.8553 8.63928 11.1935 7.79096 11.1964Z" fill="white"/>
      </svg> -->
      <svg style="position:absolute; right: 19px; top:5px" width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 2.5H3M18 2.5H7" stroke="white" stroke-linecap="round"/>
      <path d="M1 8.5H12M18 8.5H16" stroke="white" stroke-linecap="round"/>
      <path d="M1 14.5H7M18 14.5H11" stroke="white" stroke-linecap="round"/>
      <circle cx="5" cy="2.5" r="2" stroke="white"/>
      <circle cx="14" cy="8.5" r="2" stroke="white"/>
      <circle cx="9" cy="14.5" r="2" stroke="white"/>
      </svg>
      <span class="open" style="margin-right: 20px;">
        {{$ml.get("התאמת משחקים")}}
      </span>
      </div>

      <!-- <div class="divider" style="position: relative;">
        <svg style="position: absolute; top: 5px" width="1" height="17" viewBox="0 0 1 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="0.5" y1="2.95695e-08" x2="0.499999" y2="17" stroke="#06364B"/>
        </svg>
      </div> -->


      <div class="btn-options" @click="$router.push({path: '/search'})" style="position:relative; padding: 4px 0px 4px 0px !important;width: 160px; border-radius: 16px; margin-left: 5px;">
      <!-- <svg style="position:absolute; right: 22px; top:3px" width="16" height="19" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7.77844" cy="8.72266" r="5.50019" transform="rotate(-45 7.77844 8.72266)" stroke="white" stroke-width="2"/>
      <line x1="12.0236" y1="12.2559" x2="15.5591" y2="15.7914" stroke="white" stroke-width="2" stroke-linecap="round"/>
      </svg> -->
      <svg style="position:absolute; right: 22px; top:4px" width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="9" y="3" width="10" height="14" rx="2" transform="rotate(12 9 3)" fill="#06364B" stroke="white"/>
      <rect x="3" y="2.00195" width="10" height="14" rx="2" fill="#06364B" stroke="white"/>
      </svg>

      <span class="open" style="margin-right: 20px;">
        {{$ml.get("לכל המשחקים")}}
      </span>
      </div>


      <!-- <div class="loc-div rest" style="padding: 4px 5px 4px 0px; text-overflow: ellipsis;overflow: hidden;white-space: nowrap;" v-if="locations.length">
        <span class="locations">{{ locations }}</span>
      </div> -->
    </div>

  </button>
</template>

<script>
import { mapGetters } from 'vuex'
import store from "../../store";

export default {
  data() {
    return {
      data: [],
    }
  },
  props:{
    dots:{
            first:false,
            second:false,
            third:false,
            fourh:false,
            fifth:false,
            sixth:false
      },
    muted:false
  },
  methods: {
    translated(translate){
      if (this.$store.getters['lang-store/data']){
        return translate.find(item=>{
          if(this.$store.getters['lang-store/data']=='eng')
            {
              return item.langKey === "en"
            }
            else
            {
            return item.langKey === this.$store.getters['lang-store/data']
            }
        }).data.name
      }
    },
  },
  computed: {

    ...mapGetters({
      settings: 'playlist/settings',
    }),
    direction(){
      return this.$store.getters['lang-store/direction'];
    },
    locations() {
        return   this.$store.getters['playlist-locations/data']
          .filter(n => this.settings.locations.find(z => z == n.id_setting))
            .map(n => this.translated(n.translation) !=="" ? this.translated(n.translation) : n.translation[0].data.name  )
          .join(', ') || '';
      },

    },
    created() {

    }

}

</script>

<style lang="scss" scoped>
.btn-options{
  background: #06364B;
  border-radius: 13px;
}
.loc-div{
    width: 220px;
  }
  @media (max-width: 410px){
    .loc-div{
    width: 200px !important;
  }
  }
  @media (max-width: 360px){
    .loc-div{
    width: 170px !important;
  }
  }

.settings {
  
  color: #fff;
  font-size: 12px;
  padding: 8px;

  display: flex;
  flex-direction: row;
  align-items: center;
  .locations{
    font-family: 'App';
    font-style: normal;
    font-weight: 200;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */

    text-align: right;

    color: #FFFFFF;
    // padding-left: 5px;
   margin: 0 5px;
  }
  .open {
    font-family: 'App';
    font-style: normal;
    font-weight: 200;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */

    text-align: right;

    color: #FFFFFF;
    // padding-left: 5px;
   margin: 0 5px;
   margin-right: 15px;
    
    svg {
      margin-left: 5px;
    }
  }

  .rest {
    text-align: start;
    // max-width: 150px;
    // text-overflow: ellipsis;
    // overflow: hidden;
    // white-space: nowrap;
  }
}

</style>